import { type ChangeEvent } from "react";

import { faCloudArrowUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import styled, { useTheme } from "styled-components";

import { Spinner } from "shared/atoms/Spinner";

interface Props {
  accept: string;
  error?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  text: string;
  handleUploadFile: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const MediaField: React.FC<Props> = ({ accept, error, isDisabled, isLoading, text, handleUploadFile }) => {
  const theme = useTheme();

  return (
    <>
      <Button
        disabled={isDisabled || isLoading}
        component="label"
        fullWidth
        variant="contained"
        startIcon={<FontAwesomeIcon icon={faCloudArrowUp} color={theme.colors.redesign.b100} />}
        sx={{
          backgroundColor: theme.colors.redesign.b15,
          border: error && `1px solid #d32f2f`,
          boxShadow: "none",
          color: theme.colors.redesign.b100,
          margin: 0,
          padding: "16px",
        }}
      >
        {text}
        {isLoading && <Spinner style={{ height: "24px", width: "24px", marginLeft: "8px" }} />}
        <VisuallyHiddenInput type="file" accept={accept} onChange={handleUploadFile} />
      </Button>
      {error && <Error>{error}</Error>}
    </>
  );
};

const VisuallyHiddenInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const Error = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  margin: 3px 14px 0;
  color: #d32f2f;
`;
